import { Styles, generateClasses } from 'netline-ui';

export const versionContentClasses = generateClasses('VersionContent', ['root', 'titleText', 'content'] as const);

const styles: Styles = ({ theme: { spacing } }) => ({
  [`&.${versionContentClasses.root}`]: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  [`.${versionContentClasses.titleText}`]: {
    flex: 1,
  },
  [`.${versionContentClasses.content}`]: {
    overflowY: 'auto',
    marginRight: spacing(3),
  },
});

export default styles;
